<template>
  <div id="file-drag-drop">
    <v-toolbar flat v-if="!notitle">
      <v-spacer></v-spacer>
      <v-toolbar-title>Drag-n-Drop Uploader </v-toolbar-title>
      <v-divider
        class="mx-2"
        inset
        vertical
      ></v-divider>
    </v-toolbar>
    <div v-else style="padding-top: 20px;">
    </div>
    <div v-if ="url != null" class="url-text">
      Upload to Folder: <br/>
      {{url}}
    </div>
    <div v-else class="url-error">
      No folder selected for upload
    </div>
    <form ref="fileform" style="margin-top: 0px;">
      <span class="drop-files">Drop files here to upload</span>
    </form>
  
    <div class="progress-bar">
      <progress max="100" :value.prop="uploadPercentage"></progress>
    </div>
    <a class="submit-button" v-on:click="submitFiles()" v-show="files.length > 0 && submitReady">Upload</a>
    <div v-for="(file, key) in files" :key="key" class="file-listing">
      <!-- <img class="preview" v-bind:ref="'preview'+parseInt( key )" />  -->
      <abbr :title="file.name">{{trimStr(file.name, 35)}}</abbr>
      <div class="remove-container">
        <a class="remove" v-on:click="removeFile( key )">Remove</a>
      </div>
    </div>
  
    <!-- <a class="submit-button" v-on:click="submitFiles()" v-show="files.length > 0 && submitReady">Upload</a> -->
  </div>
</template>

<script>
import axiosInstances from '@/../../coreui/server/axiosInstances'
export default {
  props: ['filecallback', 'saveCallback', 'server', 'url',  'notitle', 'baseURL', 'subdir', 'selectedFolder'],
  data () {
    return {
      dragAndDropCapable: false,
      files: [],
      uploadPercentage: 0,
    }
  },
  watch: {
    files: {
      handler(val) {
        if (this.filecallback) this.filecallback(val)
      }
    },
  },
  mounted () {
    //  Determine if drag and drop functionality is capable in the browser
    this.dragAndDropCapable = this.determineDragAndDropCapable()
    //  If drag and drop capable, then we continue to bind events to our elements.
    if (this.dragAndDropCapable) {
      /* Listen to all of the drag events and bind an event listener to each
      for the fileform. */
      ['drag', 'dragstart', 'dragend', 'dragover', 'dragenter', 'dragleave', 'drop'].forEach(function (evt) {
        /*
          For each event add an event listener that prevents the default action
          (opening the file in the browser) and stop the propagation of the event (so
          no other elements open the file in the browser)
        */
        this.$refs.fileform.addEventListener(evt, function (e) {
          e.preventDefault()
          e.stopPropagation()
        }, // .bind(this),
        false)
      }.bind(this))

      //  Add an event listener for drop to the form
      this.$refs.fileform.addEventListener('drop', function (e) {
        for (let i = 0; i < e.dataTransfer.files.length; i++) {
          this.files.push(e.dataTransfer.files[i])
          // this.getImagePreviews()
          this.uploadPercentage = 0
        }
      }.bind(this))
    }
  },

  methods: {
    submitReady () {
      if (this.selectedFolder != undefined && this.selectedFolder != null) return true
      return false
    },
    trimStr(str, len) {
      if (str.length > len) {
        return str.substr(0, 20) + '...' + str.substr(str.length-10, str.length);
      }
      return str
    },
    //  Determines if the drag and drop functionality is in the window
    determineDragAndDropCapable () {
      /*
        Create a test element to see if certain events
        are present that let us do drag and drop.
      */
      var div = document.createElement('div')

      /*
        Check to see if the `draggable` event is in the element
        or the `ondragstart` and `ondrop` events are in the element. If
        they are, then we have what we need for dragging and dropping files.

        We also check to see if the window has `FormData` and `FileReader` objects
        present so we can do our AJAX uploading
      */
      return (('draggable' in div) ||
        ('ondragstart' in div && 'ondrop' in div)) &&
        'FormData' in window &&
        'FileReader' in window
    },

    /* Submits the files to the server */
    submitFiles () {
      /* Initialize the form data */
      let formData = new FormData()

      /* Iteate over any file sent over appending the files to the form data. */
      for (var i = 0; i < this.files.length; i++) {
        let file = this.files[i]
        formData.append('files[' + i + ']', file)
      }
      var self = this
      console.log('SERVER: ', this.server)
      // for (var value of formData.values()) {
      //   // console.log(value);
      // }
      /* Make the request to the POST /file-drag-drop URL */
      let sserver = this.server == 'login' ? axiosInstances.loginServer : axiosInstances.apiServer
      let purl = '/upload/'
      if (this.server == 'file') {
        sserver = axiosInstances.fileServer
        let rootdir = this.url.substring(0, this.url.substr(1).indexOf('/')+2) 
        purl = this.baseURL //'/files' + rootdir 
        console.log(this.url, rootdir)
        if (this.url.length > rootdir.length) {
          purl = purl + '?subdir=' + this.subdir //this.url.substr(rootdir.length)
        }
        console.log('upload url: ', purl)
      }
      console.log('URL: ', purl)
      // return
      sserver.post(purl, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        onUploadProgress: function (progressEvent) {
          this.uploadPercentage = parseInt(Math.round((progressEvent.loaded * 100) / progressEvent.total))
        }.bind(this)
      }
      ).then(function () {
        self.files = []
        self.uploadPercentage = 0
        if (self.saveCallback) self.saveCallback()
      })
      .catch(function (ex) {
        console.log('FAILURE: ', ex)
      })
    },

    //  Removes a select file the user has uploaded
    removeFile (key) {
      this.files.splice(key, 1)
    }
  }
}
</script>

<style>
  form {
    display: block;
    height: 200px;
    width: 400px;
    background: rgb(121, 119, 119);
    margin: auto;
    margin-top: 40px;
    text-align: center;
    line-height: 200px;
    border-radius: 4px;
  }
  
  div.progress-bar {
    width: 400px;
    margin: auto;
    padding: 0px;
  }

  div.url-text {
    width: 400px;
    margin: auto;
    padding: 5px;
    text-align: center;
  }

  div.url-error {
    width: 400px;
    margin: auto;
    padding: 5px;
    text-align: center;
    color: red;
  }

  div.file-listing {
    width: 400px;
    margin: auto;
    padding-top: 3px;
    border-bottom: 1px solid #ddd;
  }
  
  div.file-listing img {
    height: 100px;
  }
  
  div.remove-container {
    float: right;
    text-align: right;
  }
  
  div.remove-container a {
    color: red;
    cursor: pointer;
  }
  
  a.submit-button {
    display: block;
    margin: auto;
    text-align: center;
    width: 200px;
    padding: 5px;
    text-transform: uppercase;
    background-color: #CCC;
    color: rgb(27, 13, 228);
    font-weight: bold;
    margin-top: 0px;
    margin-bottom: 10px;
  }
  
  progress {
    width: 400px;
    margin: auto;
    display: block;
    margin-top: 20px;
    margin-bottom: 10px;
  }
  abbr[title] {
    border-bottom: none !important;
    cursor: inherit !important;
    text-decoration: none !important;
  }
</style>

